/**
 * Legacy CustomersApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.customersApi`) keep resolving.
 *
 * The actual CustomersApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/customers/customers-api.service.ts
 */
angular.module("acme.common.service.customersApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
